// extracted by mini-css-extract-plugin
export default {"inactiveButton":"UECyPuJ3oTH_PCF8yR09","button":"HWjotpuv6iwOjQV7invr"};